import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TicketCouponIcon } from './icons/ticket-coupon-icon';
import { TicketVoucherIcon } from './icons/ticket-voucher-icon';
import { useTranslation } from 'react-i18next';
import * as ticketType from '../config/constants/ticket-type';
import { When } from './utils/when';
var TicketWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"])));
var TicketValue = styled.h1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", " !important;\n  font-weight: 700;\n  font-style: normal;\n  text-transform: uppercase;\n  max-width: ", " !important;\n  position: absolute;\n  color: #108542;\n  margin-left: 40px;\n\n  @media screen and (max-width: 320px) {\n    transform: translateX(20%);\n  }\n"])), function (props) {
  return props.font;
}, function (props) {
  return props.maxWidth;
});
var TicketCurrency = styled.text(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: 700;\n"])));
var defaultSizes = {
  font: '20px',
  fontMaxWidth: '200px',
  ticketHeight: '110',
  ticketWidth: '310'
};
var mediumSizes = {
  font: '16px',
  fontMaxWidth: '220px',
  ticketHeight: '130',
  ticketWidth: '330'
};
var maxSizes = {
  font: '12px',
  fontMaxWidth: '240px',
  ticketHeight: '150',
  ticketWidth: '350'
};
export function Ticket(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(defaultSizes),
      sizes = _useState[0],
      setSizes = _useState[1];

  var defineSize = function defineSize(value) {
    if (value.length <= 20) {
      return defaultSizes;
    } else if (value.length <= 50) {
      return mediumSizes;
    }

    return maxSizes;
  };

  useEffect(function () {
    if (!props.value) return;
    setSizes(_objectSpread({}, defineSize(props.value)));
  }, [props.value]);
  return /*#__PURE__*/_jsxs(TicketWrapper, {
    children: [/*#__PURE__*/_jsx(When, {
      value: props.type === ticketType.TICKET_VOUCHER,
      children: /*#__PURE__*/_jsx(TicketVoucherIcon, {
        height: sizes.ticketHeight,
        width: sizes.ticketWidth
      })
    }), /*#__PURE__*/_jsx(When, {
      value: props.type !== ticketType.TICKET_VOUCHER,
      children: /*#__PURE__*/_jsx(TicketCouponIcon, {
        height: sizes.ticketHeight,
        width: sizes.ticketWidth
      })
    }), /*#__PURE__*/_jsxs(TicketValue, {
      font: sizes.font,
      maxWidth: sizes.fontMaxWidth,
      children: [/*#__PURE__*/_jsx(When, {
        value: props.type !== ticketType.TICKET_VOUCHER,
        children: props.value
      }), /*#__PURE__*/_jsxs(When, {
        value: props.type === ticketType.TICKET_VOUCHER,
        children: [/*#__PURE__*/_jsx(TicketCurrency, {
          children: "R$"
        }), props.value + t('BONUS_VALUE')]
      })]
    })]
  });
}